import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { LandingBg } from "../assets/images";
import EntertainmentPark from "../components/Landing/EntertainmentPark";
import Banner from "../components/Landing/Banner";
import ParksHeader from "../components/Landing/ParksHeader";
import Footer, { FooterMobile } from "../components/Footer";
import { fetchAllParks } from "../services/parksServices";
import { Colors } from "../ColorConstants";
import { getCart } from "../services/cartServices";
import { toast } from "react-toastify";
import { updateGuestCart } from "../services/guestServices";
import { trackFBEvent } from "../analytics/index";
import { EVENT } from "../analytics/constants";
import { segColors, segments } from "../tempConst";
import SpinWheel from "../components/SpinWheel";
import { useLocation } from "react-router-dom";

const Landing = () => {
  const location = useLocation();   
  const name = location.state?.name;
  const [data, setData] = useState({});
  const [showCart, setShowCart] = useState(false);
  const [count, setCount] = useState(0);
  let cartId = localStorage.getItem("cartId");
  const apiToken = localStorage.getItem("token");

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "Landing Page" });
    fetchData();
    fetchCart();
    if (cartId) {
      addCart();
    }
  }, []);

  const fetchData = async () => {
    try {
      let res = await fetchAllParks();
      setData(res?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchCart = async () => {
    try {
      if (apiToken) {
        let res = await getCart("");
        if (res.status === 201) {
          const isEmptyObject = Object.keys(res.data.data).length === 0;
          if (isEmptyObject) {
            setShowCart(false);
          } else {
            setShowCart(true);
            setCount(res?.data?.data?.items?.length);
          }
        }
      } else {
        console.log("no token");
      }
    } catch (err) {
      console.log(err);
    }
  };
  const addCart = async () => {
    try {
      let res = await updateGuestCart(cartId);
    } catch (err) {
      toast.error(err?.message);
      localStorage.removeItem("cartId");
    }
  };
  return (
    <MainDiv>
      <Banner count={count} showCart={showCart} loginName={name}/>
      <SecondSubView>
        <ParksHeader />
        <ParksDiv>
          <EntertainmentPark data={data} />
        </ParksDiv>
      </SecondSubView>
      <FooterContainer>
        <Footer />
      </FooterContainer>
      <FooterMobile />
    </MainDiv>
  );
};

const MainDiv = styled.div`
  background-image: url(${LandingBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
`;

const SecondSubView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3rem;
  margin-bottom: 3rem;
  @media (max-width: 768px) {
    margin-top: 1rem;
  }
`;

const WelcomeText = styled.span`
  color: ${Colors.veryDarkBlue};
  text-align: center;
  font-family: Poppins;
  font-size: 2rem;
  font-style: normal;
  font-weight: 400;
  padding: 0 1rem;
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;
const WelcomeText2 = styled(WelcomeText)`
  // margin-top: 0rem;
  font-weight: 600;
`;

const InfoText = styled.span`
  color: ${Colors.grey40};
  text-align: center;
  align-self: center;
  font-family: Poppins;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  margin-top: 1.5rem;
  padding: 0 1.5rem;
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const ParksDiv = styled.div`
  width: 70vw;
  padding-top: 2rem;
  @media (max-width: 1210px) {
    width: 100%;
  }
  @media (max-width: 768px) {
    margin-top: 0rem;
  }
`;

const FooterContainer = styled.div`
  @media only screen and (max-width: 576px) {
    display: none;
  }
`;

export default Landing;
